<template>
  <div  class="tabs">
    <div class="mybats-mian">
      <div class="mybats-item" v-for="(item, index) in tabs" :key="index" >
        <div class="item-head" @click="handleClickFun(index)">
          <i :class="'iconfont '+item.url"></i><br>
          <span :class="crrentIndex == index?'c-action':'c-default'">{{item.title}}</span>
          <span class="hide">西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所</span>
        </div>
      </div>
    </div>
    <div :class="txtLBool?'txt-l':'hide'">
      <span>{{ value }} </span>
      <span id="copyBtn" :data-clipboard-text="value" data-clipboard-action="copy"  @click="copyValue">复制</span>
    </div>

    <!-- 系统公告 -->
    <div class="notice-card-wrapper">
      <div class="inner-container">
        <span >⚠️ ⚠️ ⚠️ 必读: 本会所不支持任何形式的转账 ⚠️ ⚠️ ⚠️ 不支持任何形式的转账</span>
      </div>
    </div>

  </div>

</template>

<script>
import Clipboard from 'clipboard'
export default {
  name:'mytabs',
  data () {
    return {
      tabs:[],
      txtLBool:false,
      crrentIndex: 0,
      value:'',
    }
  },
  mounted() {
    this.tabs = this.$store.state.tabs;
  },
  methods: {
    handleClickFun (index) {
      this.txtLBool= true
      this.crrentIndex = index
      this.value = this.tabs[this.crrentIndex].value;
      //console.log(index);
      if(index ==3){
        this.$win.location.href = 'sms:425-999-6494';
      }
    },
    goWxchat() {
      window.location.href = 'weixin://';
    },
    copyValue () {
      let th = this;
      var clipboard = new Clipboard('#copyBtn')
      clipboard.on('success', e => {
        th.$notify.success('复制成功')
        //  释放内存
        clipboard.destroy()
        if(this.crrentIndex == 0){
          this.goWxchat()
        }
      })
      clipboard.on('error', e =>{
        // 不支持复制
        th.$notify.error('该浏览器不支持复制')
        // 释放内存
        clipboard.destroy()
      })
    },
  }
}
</script>

<style  lang="less" scoped>
i{font-size: 1.5rem;}
.tabs{
  padding-top:1rem ;
  padding-bottom:1rem ;
}
.mybats-mian{display: flex; justify-content: space-between;color: #cfcfcf; background-color: #1a1a1a;}
.item-head{cursor: pointer; color:#bfbfbf; }
.mybats-item {flex: 1;font-size: 16px;}
.hide{display:none;}
#copyBtn{cursor:pointer; border: 1px solid #8c939d;border-radius: 10px;}
.txt-l{display: flex;color: #cfcfcf;padding: 10px;}
.txt-l span{flex: 1; text-align: center}
/*文字滚动*/
.notice-card-wrapper {
  color:#dc143c;
  font-weight: bold;
  .inner-container {
    margin-top: 10px;
    margin-left: 20%; // 把文字弄出可见区域
    font-size: 1.3rem;
    animation: myMove 30s linear infinite; // 重点，定义动画
    animation-fill-mode: forwards;
    span{
      overflow: hidden;
      white-space: nowrap;
    }
  }
  /*文字无缝滚动*/
  @keyframes myMove {
    0% {transform: translateX(0);}
    100% {transform: translateX(-100%);}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mytabs.vue